import styled from '@emotion/styled'
import { Link } from 'found'
import { useTranslation } from 'react-i18next'

import { useTypedSelector } from '../..'
import More from '../../icons/More'
import Search from '../../icons/Search'
import Train from '../../icons/Train'
import { hideSchedule, isBusDriverUser, isMaintenanceUser } from '../../lib/roleUtils'
import { color, getColor, px, theme, unPx } from '../../Theme'
import { SelectedProps } from '../../types/App'
import FeedbackIcon from '../FeedbackIcon'
import NightMode from './NightMode'

const Container = styled.div`
  ${theme.layout.flexRow};
  ${theme.spacing.right('larger')};
  height: 100%;
  background: ${(p) => getColor(p.theme, ['white'], ['nightBlack'])};
  border-top: 1px solid ${(p) => getColor(p.theme, ['grayBlue'], ['transparent'])};
  justify-content: center;
`

const MENU_ITEMS = 4

const CenterThird = styled(Link)<SelectedProps>`
  display: block;
  text-decoration: none;
  width: ${theme.maxWidths.tab};
  text-align: center;
  ${theme.spacing.ends('smaller')};
  color: ${(p) => color(p.selected ? 'primaryGreen' : 'grayDark')};
  cursor: pointer;
  @media (max-width: ${px(unPx(theme.maxWidths.tab) * MENU_ITEMS)}) {
    width: ${100 / MENU_ITEMS}vw;
  }
`

const MenuText = styled.div`
  ${theme.text('smaller')};
`

type Props = {
  current?: string
}

function MainMenu({ current }: Props) {
  const { t } = useTranslation()

  const user = useTypedSelector((state) => state.user)
  const notification = useTypedSelector((state) => state.incidents.showNotification)

  const iconSize = 25
  const isStart = current === 'start'

  const tabs = [
    {
      key: 'start',
      icon: (
        <FeedbackIcon
          color={isStart ? 'primaryGreen' : 'grayDark'}
          notification={notification}
          styledForMainMenu
        />
      ),
      link: '/',
      show: !isMaintenanceUser(user),
    },
    {
      key: 'schedule',
      icon: <Train iconSize={iconSize} />,
      link: '/shifts',
      show: !hideSchedule(user),
    },
    {
      key: 'search',
      icon: <Search iconSize={iconSize} />,
      link: '/search',
      show: !isBusDriverUser(user),
    },
    {
      key: 'options',
      icon: <More iconSize={iconSize} />,
      link: '/options',
      show: true,
    },
  ]

  return (
    <Container>
      {tabs.map(
        ({ key, icon, link, show }) =>
          show && (
            <CenterThird key={key} selected={key === current} to={link}>
              {icon}
              <MenuText>{t(`menu.${key}`)}</MenuText>
            </CenterThird>
          )
      )}
      <NightMode key="4" />
    </Container>
  )
}

export default MainMenu
